import { Component } from '@angular/core';
import {
  CONTACT_US_ROUTE,
  NORMATIVE_INFORMATION_AND_LEGAL_BASES_ROUTE,
  OFFICES_ROUTE,
  PORTABILITY_ROUTE,
  RATES_AND_FEES_ROUTE,
  FAQS_ROUTE,
} from '@common/constants/routes.constants';
import { NavigationService } from '@services/navigation/navigation.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {

  public officesRoute: string;
  public contactUsRoute: string;
  public ratesAndFeesRoute: string;
  public portabilityRoute: string;
  public normativeInformationAndLegalBasesRoute: string;
  public faqsRoute: string;

  constructor(
    private navService: NavigationService,
  ) {
    this.contactUsRoute = CONTACT_US_ROUTE;
    this.officesRoute = OFFICES_ROUTE;
    this.ratesAndFeesRoute = RATES_AND_FEES_ROUTE;
    this.portabilityRoute = PORTABILITY_ROUTE;
    this.normativeInformationAndLegalBasesRoute = NORMATIVE_INFORMATION_AND_LEGAL_BASES_ROUTE;
    this.faqsRoute = FAQS_ROUTE;
  }

  public redirect(url: string) {
    this.navService.goTo(url);
  }
}
